<div class="pag-container">
  <!-- <h1>{{labelTest}}</h1> -->
  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <div class="header-container">
    <h1 class="bold-text header-blue">{{ 'baskets.import_from_csv_title' | translate }}</h1>
    <span [pTooltip]="disableImportBtn ? ('baskets.import_in_progress' | translate) : ''" tooltipPosition="bottom">
      <button class="import-btn" [disabled]="disableImportBtn" (click)="onImportCsvFile()">
        <i class="pi pi-arrow-down"></i>
        {{ 'baskets.import_new_csv' | translate }}
      </button>
    </span>
  </div>
  
  <div class="ui-g-12 prova" *ngIf="showTable">


    <!-- nuove colonne da guardare in issue -->
    <app-campaign-3-kontable #csvKontable [columns]="[
      { field: 'id', title: 'baskets.id', filterType: textFilter },
      { field: 'description', title: 'baskets.description', filterType: textFilter },
      { field: 'dt_import', title: 'baskets.import_date', type: 'date', filterType: dateFilter,bodyTemplate: importDateTemplate },
      { field: 'file_name', title: 'baskets.fileName', filterType: textFilter },
      { field: 'count_ok', title: 'baskets.number_record_ok', filterType: textFilter },
      { field: 'count_ko', title: 'baskets.number_record_error', filterType: textFilter },
      { field: 'error_log', title: 'baskets.error_log', filterType: noFilter }
    ]" [paginationType]="paginationType" [additionalRowCommands]="actions" [showInfoButton]="false" [showDetailsButton]="false" [showRecoverButton]="false"
      [showAddButton]="false" [showDeleteButton]="false" [showEditButton]="false" [allowSelectRow]="false"
      [filterBySingleColumn]="true" [service]="basketImportService"
      (onTableRendered)="onTableDataLoaded()">


      <!-- IMPORT DATE -->
      <ng-template #importDateTemplate let-row>
        <span class="center-number"> {{
          row.dt_import |
          date:srvCalendar.pcalendarTranslate.dateFormatFilter
          }}</span>
      </ng-template>


      <ng-template #actions let-row>

        <div class="d-flex justify-content-center">
          <button data-testid-generic="viewImportCsv" [attr.data-testid]="'viewImportCsv' + row.id"
            pTooltip="{{ 'common.view' | translate }}" class="roundedButton row-buttom-margin"
            [ngClass]="{'disabled-button': row.flg_enabled === '1'}"
            [disabled]="row.flg_enabled === '1'"
            (click)="onOpenImportDetails(row)">
            <i class="pi pi-eye icon-size"></i>
          </button>
        </div>

      </ng-template>
    </app-campaign-3-kontable>
  </div>

  <p-dialog data-testid="importCsvDialog" header="{{ 'baskets.import_products_csv' | translate }}"
    [(visible)]="showModalImportCsv" [modal]="true" [closable]="false" class="custom-dialog">

    <div class="csv-drop-area" data-testid="csvDropArea" (drop)="onCsvDrop($event)" (dragover)="onCsvDragOver($event)"
      (dragleave)="onCsvDragLeave($event)" (click)="fileInput.click()">

      <input #fileInput type="file" accept=".csv" hidden data-testid="csvFileInput"
        (change)="onCsvFileSelected($event)" />

      <div *ngIf="!csvFile" data-testid="csvEmptyState">
        <i class="pi pi-upload" style="font-size: 2rem"></i>
        <p>{{ 'baskets.drop_csv_here' | translate }}</p>
        <small>{{ 'baskets.only_csv_allowed' | translate }}</small>
      </div>

      <div *ngIf="csvFile" data-testid="csvReadyState">
        <i class="pi pi-file" style="font-size: 2rem"></i>
        <p><strong>{{ csvFile.name }}</strong></p>
        <small>{{ 'baskets.csv_ready' | translate }}</small>
      </div>
    </div>

    <div class="custom-footer">
      <button type="button" pButton data-testid="importCsvCancelButton" label="{{ 'common.cancel' | translate }}"
        icon="pi pi-times" (click)="closeImportCsvDialog()">
      </button>

      <button type="button" pButton data-testid="importCsvConfirmButton" label="{{ 'baskets.import' | translate }}"
        icon="pi pi-check" style="margin-left: .25em" [disabled]="!csvFile" (click)="onConfirmImportCsv()">
      </button>
    </div>
  </p-dialog>


</div>


// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-import-csv/basket-import-csv.component.html